<template>
	<div class="testcardmainpage">
		<div
			:class="[
				selTest == testDetails.testID ||
				(testConfigData.testID == testDetails.testID &&
					(showTestPreviewStatus || testConfigStatus))
					? 'changecolor'
					: 'ts-gridcard',
				testDetails.active ? 'pointer' : '',
			]"
			style="height: 92px;"
			@click="testDetails.active ? goToQPBuilder() : ''"
		>
			<div class="relativeclass tl-flexgrid">
				<div
					v-if="
						testConfigData.testID != testDetails.testID ||
							!showTestPreviewStatus
					"
					:class="
						testDetails.active
							? 'testgridgreencolordynamic'
							: 'testgridredcolordynamic'
					"
					:style="{ height: testDetails.active ? '115%' : '' }"
				></div>
				<div
					class="d-flex align-items-center justify-content-between"
					style="width: 65%"
				>
					<div class="d-flex flex-column">
						<div class="tp-text tp-cardhead ml-1 d-flex align-items-center">
							<span class="ml-0 align-items-center" v-if="testDetails.active">
								<img src="../../../assets/active.svg" alt="" class="mb-1"
							/></span>
							<span v-else class="ml-0 align-items-center"
								><img src="../../../assets/inactive.svg" alt="" class="mb-1"
							/></span>
							<span
								class="d-inline-block text-truncate ml-1"
								style="max-width: 100%"
								v-b-popover.hover.top="testDetails.name"
							>
								{{ testDetails.name | testNameFilter }}
							</span>
						</div>
						<div class="d-flex align-items-center flex-wrap gap-1">
							<div class="ml-1 fs-11">
								<span
									:class="
										testDetails.difficultyLevel == 'Easy'
											? 'pinktext'
											: testDetails.difficultyLevel == '--'
											? 'disabletext'
											: 'greytext'
									"
									>Easy / </span
								><span
									:class="
										testDetails.difficultyLevel == 'Medium'
											? 'pinktext'
											: testDetails.difficultyLevel == '--'
											? 'disabletext'
											: 'greytext'
									"
									>Medium </span
								><span
									:class="
										testDetails.difficultyLevel == 'Difficult'
											? 'pinktext'
											: testDetails.difficultyLevel == '--'
											? 'disabletext'
											: 'greytext'
									"
									>/ Difficult</span
								>
							</div>
							<img src="../../../assets/greydot.svg" alt="" />
							<div class="d-flex">
								<span
									:class="
										testDetails.autoCorrection == true ? 'pinktext' : 'greytext'
									"
									>Auto Corrected / </span
								><span
									:class="
										testDetails.autoCorrection == false
											? 'pinktext'
											: 'greytext'
									"
								>
									Evaluated
								</span>
							</div>
							<img src="../../../assets/greydot.svg" alt="" />
							<div>
								<span
									:class="
										testDetails.setPricing == false ? 'pinktext' : 'greytext'
									"
									>Free / </span
								><span
									:class="
										testDetails.setPricing == true ? 'pinktext' : 'greytext'
									"
								>
									Paid
									<span v-if="testDetails.setPricing == true"
										>(Rs.{{
											testDetails.setPricing == true
												? testDetails.finalPrice
												: ""
										}})</span
									>
								</span>
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-around" style="width: 40%">
						<div class="d-flex flex-column">
							<span class="tp-cardhead">Sections</span>
							<span
								v-if="testDetails.numberOfSections < 10"
								class="greennumbertext"
								>0{{ testDetails.numberOfSections }}</span
							>
							<span v-else class="greennumbertext">{{
								testDetails.numberOfSections
							}}</span>
						</div>

						<div class="d-flex flex-column">
							<span class="tp-cardhead">Candidates</span>
							<span
								v-if="testDetails.candidateCount < 10"
								class="bluenumbertext"
								>0{{ testDetails.candidateCount }}</span
							>
							<span v-else class="bluenumbertext">{{
								testDetails.candidateCount
							}}</span>
						</div>
						<div class="d-flex flex-column">
							<span class="tp-cardhead">Marks</span>
							<span v-if="testDetails.marks < 10" class="yellownumbertext"
								>0{{ testDetails.marks.toString().slice(0, 4) }}</span
							>
							<span v-else class="yellownumbertext">{{
								testDetails.marks.toString().slice(0, 7)
							}}</span>
						</div>
					</div>
				</div>
				<div v-if="!testDetails.active" class="inactive-text-box">Inactive</div>
				<div v-else class="active-text-box">Active</div>

				<div
					style="width: 10%"
					class="d-flex justify-content-end"
					v-if="!testDetails.active"
					@click.stop
				>
					<template v-if="leaderboardAdminAccess">
						<img
							v-if="testDetails.publicAvailability"
							v-b-popover.hover.top="'Public'"
							src="../../../assets/Testunlockgreen.svg"
							alt=""
							class="m-1 pointer"
							@click.stop="publicAvailabilityModal = true"
						/>
						<img
							v-else
							v-b-popover.hover.top="'Private'"
							src="../../../assets/Testlockred.svg"
							alt=""
							class="m-1 pointer"
							@click.stop="publicAvailabilityModal = true"
						/>
					</template>
					<img
						v-if="
							(!showTestPreviewStatus ||
								testConfigData.testID != testDetails.testID) &&
								this.roles.includes('GET_QUESTION') &&
								this.roles.includes('GET_SECTION')
						"
						@click.stop="(showPreviewTest = true), saveTestPreview()"
						v-b-popover.hover.top="'Test Preview'"
						src="../../../assets/preview eye.svg"
						alt=""
						class="m-1 pointer"
					/>
					<img
						v-else-if="
							showTestPreviewStatus &&
								testConfigData.testID == testDetails.testID &&
								this.roles.includes('GET_QUESTION') &&
								this.roles.includes('GET_SECTION')
						"
						@click="(showPreviewTest = false), saveTestPreview()"
						v-b-popover.hover.top="'Close Preview'"
						src="../../../assets/visibility_off.svg"
						alt=""
						class="m-1 pointer"
					/>
					<div
						v-if="roles.includes('ACTIVATE_TEST')"
						class="mr-2 pointer"
						v-b-popover.hover.top="'Activate'"
						@click="testModal = !testModal"
					>
						<img src="../../../assets/activate.svg" alt="" />
					</div>
				</div>

				<div
					v-else
					style="width: 10%"
					class="d-flex justify-content-end"
					@click.stop=""
				>
					<div class="d-flex align-items-center" v-if="!testDetails.editoption">
						<img
							v-if="testDetails.isLocked"
							@click.stop="locktestModal = !locktestModal"
							v-b-popover.hover.top="'Unlock'"
							src="../../../assets/lockicoinactive.svg"
							alt=""
							class="m-1"
						/>
						<img
							v-else
							@click.stop="locktestModal = !locktestModal"
							v-b-popover.hover.top="'Lock'"
							src="../../../assets/lockiconactive.svg"
							alt=""
							class="m-1"
						/>
						<template v-if="leaderboardAdminAccess">
							<img
								v-if="testDetails.publicAvailability"
								v-b-popover.hover.top="'Public'"
								src="../../../assets/Testunlockgreen.svg"
								alt=""
								class="m-1 pointer"
								@click.stop="publicAvailabilityModal = true"
							/>
							<img
								v-else
								v-b-popover.hover.top="'Private'"
								src="../../../assets/Testlockred.svg"
								alt=""
								class="m-1 pointer"
								@click.stop="publicAvailabilityModal = true"
							/>
						</template>
						<img
							v-if="roles.includes('GET_CONFIG')"
							src="../../../assets/icons/testconfigicon.svg"
							@click.stop="
								(testDetails.activecard = !testDetails.activecard),
									saveTestConfig(testDetails)
							"
							v-b-popover.hover.top="'Configuration'"
							alt=""
							class="m-1"
						/>
						<img
							v-if="
								(!showTestPreviewStatus ||
									testConfigData.testID != testDetails.testID) &&
									this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click.stop="(showPreviewTest = true), saveTestPreview()"
							v-b-popover.hover.top="'Test Preview'"
							src="../../../assets/preview eye.svg"
							alt=""
							class="ml-1 pointer"
						/>
						<img
							v-else-if="
								showTestPreviewStatus &&
									testConfigData.testID == testDetails.testID &&
									this.roles.includes('GET_QUESTION') &&
									this.roles.includes('GET_SECTION')
							"
							@click.stop="(showPreviewTest = false), saveTestPreview()"
							v-b-popover.hover.top="'Close Preview'"
							src="../../../assets/visibility_off.svg"
							alt=""
							class="ml-1 pointer"
						/>

						<img
							v-if="
								roles.includes('PUT_TEST') ||
									roles.includes('DELETE_TEST') ||
									roles.includes('GET_TEST_INDIVIDUAL') ||
									roles.includes('GET_TEST_GROUP')
							"
							src="../../../assets/ellipseicon.svg"
							alt=""
							class="m-2"
							v-b-popover.hover.top="'View More'"
							@click.stop="$emit('test-card-option', testDetails.testID)"
						/>
					</div>

					<transition name="slide-fade">
						<div
							class="ts-cardeditoptions pointer"
							v-if="testDetails.editoption"
						>
							<b-popover
								:target="testDetails.testID"
								:placement="'top'"
								triggers="hover focus"
							>
								<span v-if="testDetails.allSectionsHaveQuestions == true">
									Share
								</span>
								<span v-else-if="testDetails.numberOfSections == 0"
									>Add sections to the test</span
								>
								<span v-else-if="testDetails.allSectionsHaveQuestions == false"
									>&nbsp;All sections do not contain questions.</span
								>
							</b-popover>
							<img
								v-if="roles.includes('CLONE_TEST')"
								v-b-popover.hover.top="'Clone Test'"
								@click.stop="(cloneTestModal = !cloneTestModal), copyingVal()"
								src="../../../assets/clonetest.svg"
								alt=""
								class="m-1"
							/>
							<img
								v-if="
									roles.includes('GET_TEST_INDIVIDUAL') ||
										roles.includes('GET_TEST_GROUP')
								"
								src="../../../assets/singleusericon.svg"
								:id="testDetails.testID"
								class="m-1"
								:class="
									testDetails.allSectionsHaveQuestions == true
										? ''
										: ' disableSharing '
								"
								@click.stop="
									testDetails.allSectionsHaveQuestions == false
										? ''
										: goToSharePage()
								"
								alt=""
							/>

							<img
								v-if="roles.includes('PUT_TEST')"
								src="../../../assets/pencilicon.svg"
								@click.stop="(testModal = !testModal), copyingVal()"
								v-b-popover.hover.top="'Edit'"
								alt=""
								class="m-1"
							/>
							<img
								v-if="roles.includes('DELETE_TEST')"
								v-b-popover.hover.top="'Delete'"
								src="../../../assets/deleteicon.svg"
								@click.stop="deleteModal = !deleteModal"
								alt=""
								class="m-1"
							/>

							<img
								src="../../../assets/closeicon.svg"
								v-b-popover.hover.top="'Close'"
								alt=""
								class="m-1"
								@click.stop="$emit('test-card-option', null)"
							/>
						</div>
					</transition>
				</div>
			</div>
		</div>
		<template v-if="deleteModal">
			<DeleteTest
				:deleteModal="deleteModal"
				:testDetails="testDetails"
				:topicID="$route.params.topicID"
				:context="this"
				@hide="deleteModal = false"
				@resetPagination="$emit('resetPagination', showindex)"
				@cardClose="$emit('card-close', testDetails.testID)"
			/>
		</template>
		<template v-if="testModal">
			<EditTest
				:testModal="testModal"
				@resetPagination="$emit('resetPagination')"
				:testDetails="testDetails"
				@hide="testModal = false"
				:topicID="$route.params.topicID"
				:context="this"
				@cardClose="$emit('card-close', testDetails.testID)"
				@resetSelTest="selTest = ''"
				@lengthofTotalTopicsWhenedidted="
					$emit('lengthofTotalTopicsWhenedidted', this.showindex, this.clone)
				"
			/>
		</template>
		<template v-if="cloneTestModal">
			<CloneTest
				:cloneTestModal="cloneTestModal"
				@hide="cloneTestModal = false"
				:clone="testDetails"
				@cardClose="$emit('card-close', testDetails.testID)"
				:topicID="$route.params.topicID"
				:context="this"
				@resetPagination="$emit('resetPagination')"
			/>
		</template>

		<template v-if="locktestModal">
			<TestLock
				:locktestModal="locktestModal"
				@hide="locktestModal = false"
				:testDetails="testDetails"
				:topicID="$route.params.topicID"
				:context="this"
				@resetPagination="$emit('resetPagination')"
			/>
		</template>
		<template v-if="publicAvailabilityModal">
			<PublicAvailability
				:showModal="publicAvailabilityModal"
				:testDetails="testDetails"
				:topicID="$route.params.topicID"
				@hide="publicAvailabilityModal = false"
				@updated="onPublicAvailabilityUpdated"
			/>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import successToast from "../../mixin/toast.js";
import errorToast from "../../mixin/toast";
import DeleteTest from "../../../controllers/Test/modals/DeleteTest.vue";
import EditTest from "../../../controllers/Test/modals/EditTest.vue";
import CloneTest from "../../../controllers/Test/modals/CloneTest.vue";
import TestMixins from "../../../controllers/Test/TestMixins.js";
import TestLock from "../../../controllers/Test/modals/TestLock.vue";
import PublicAvailability from "@/controllers/Test/modals/PublicAvailability.vue";
export default {
	name: "TestCardGrid",
	mixins: [successToast, errorToast, TestMixins],
	props: {
		showindex: Number,
		selectFirstCard: Object,
		testDetails: Object,
		simp: Boolean,
		type: String,
		sort: Number,
		ttype: String,
		tsort: Number,
	},
	components: {
		DeleteTest,
		EditTest,
		CloneTest,
		TestLock,
		PublicAvailability,
	},
	data() {
		return {
			selTest: "",
			locktestModal: false,
			show: false,
			deleteModal: false,
			testModal: false,
			cloneTestModal: false,
			publicAvailabilityModal: false,
			showTestConfig: false,
			clone: { ...this.testDetails },
			options: [
				{ item: true, name: "Yes" },
				{ item: false, name: "No" },
			],
		};
	},
	created() {
		if (this.showPreviewTest) {
			this.$store.commit("testVUEX/saveshowPreviewTest", {
				preview_status: false,
			});
		}
		this.testDetails["activecard"] = false;
		this.config_status = true;
	},
	computed: {
		...mapGetters("testVUEX", {
			showTestPreviewStatus: "getShowTestPreviewStatus",
		}),
		...mapGetters("testVUEX", {
			testConfigData: "getTestConfigData",
			testConfigStatus: "getTestConfigStatus",
		}),
		...mapGetters("topicVUEX", {
			selectedTopic: "getSelectedTopic",
		}),
		...mapGetters(["roles"]),
		...mapGetters("userVUEX", {
			leaderboardAdminAccess: "getleaderboardAdminAccess",
		}),
	},
	methods: {
		copyingVal() {
			this.selTest = this.testDetails.testID;
			this.clone = { ...this.testDetails };
		},
		onPublicAvailabilityUpdated(data) {
			this.testDetails.publicAvailability = data.publicAvailability;
			if ("setPricing" in data) this.testDetails.setPricing = data.setPricing;
			if ("leaderboard" in data)
				this.testDetails.leaderboard = data.leaderboard;
			if ("leaderboardCategory" in data)
				this.testDetails.leaderboardCategory = data.leaderboardCategory;
			this.$emit("resetPagination");
		},
	},
};
</script>

<style>
.tl-flexgrid {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.testgridgreencolordynamic {
	width: 4px;
	height: 69px;
	border-radius: 2px;
	position: absolute;
	background: #4ef085;
	left: -10px;
	top: -12px;
}
.testgridredcolordynamic {
	width: 4px;
	height: 69px;
	border-radius: 2px;
	position: absolute;
	background: red;
	left: -10px;
	top: -12px;
}
</style>

<style>
.tl-flexgrid {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.inactive-text-box {
	background: #ffeeee;
	border-radius: 3px;
	padding: 5px;
	width: 80px;
	text-align: center;
	font-weight: 400;
	font-size: 12px;
	color: #ad1927;
}
.active-text-box {
	background: #ccfacb;
	border-radius: 3px;
	padding: 5px;
	width: 80px;
	text-align: center;
	font-weight: 400;
	font-size: 12px;
	color: #038e00;
}
.clonetestname {
	margin-top: 15px;
	width: 100%;
	height: 37px;
	background: #f5f5f5;
}

.changecolor {
	background: #ebf5fe;
	border: 2px solid #84bae7;
	border-radius: 5px;
	padding: 15px;
	width: 100%;
}

.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(10px);
	opacity: 0;
}
.hidebutton.btn-secondary {
	background-color: #fff !important;
	color: black !important;
	border: none;
}
.clonetest-name-validation-icon {
	padding-right: 7px;
	padding-left: 5px;
	position: absolute;
	top: 5px;
	right: 3px;
	background: rgb(255, 255, 255);
}
</style>
